import React, {type PropsWithChildren, type ReactElement, createContext, useContext} from 'react'

type ConfigContextValue = {
  trustDomain: string
  clientId: string
  lang: string
  currency?: string
  device: 'desktop' | 'mobile'
  country?: string
  makeUrl?: (url: string) => string
}
type Props = PropsWithChildren<ConfigContextValue>

const Context = createContext<ConfigContextValue | null>(null)

export function useConfigContext() {
  const context = useContext(Context)

  if (context === null) {
    throw new Error('useConfigContext must be used within a ConfigProvider')
  }

  return context
}

export function BoundCardConfigContext({children, ...config}: Props): ReactElement<Props> {
  return <Context.Provider value={config}>{children}</Context.Provider>
}
